import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";

var _EyeOpen, _EyeClose;

const _excluded = ["visible"],
      _excluded2 = ["defaultVisible"];
import React, { forwardRef, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { EyeClose, EyeOpen } from '@resultadosdigitais/tangram-react-icons';
import Input from '../Input';
import IconButton from '../IconButton';
import { useMergeRefs } from '../hooks';
const StyledIconButton = styled(IconButton).withConfig({
  displayName: "Password__StyledIconButton",
  componentId: "sc-4nqi3h-0"
})(["height:auto;&:hover:not([disabled]){background:none;}"]);
const EyeButton = styled(_ref => {
  let {
    visible
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledIconButton, _extends({
    kind: IconButton.kinds.neutral
  }, rest), visible ? _EyeOpen || (_EyeOpen = /*#__PURE__*/React.createElement(EyeOpen, {
    title: "password shown icon",
    titleId: "eyeOpen"
  })) : _EyeClose || (_EyeClose = /*#__PURE__*/React.createElement(EyeClose, {
    title: "hidden password icon",
    titleId: "eyeClose"
  })));
}).withConfig({
  displayName: "Password__EyeButton",
  componentId: "sc-4nqi3h-1"
})(["padding:0;&:active{box-shadow:none;}svg{fill:var(--neutral-icon-low-emphasis);}&:hover{background:none;svg{fill:var(--neutral-icon-high-emphasis);}}"]);
const Password = /*#__PURE__*/forwardRef((_ref2, ref) => {
  let {
    defaultVisible
  } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  const inputRef = useRef();
  const [visible, setVisible] = useState(defaultVisible);

  const handleVisibility = () => {
    var _inputRef$current;

    const length = (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.value.length;
    setTimeout(() => {
      var _inputRef$current2;

      return (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.setSelectionRange(length, length);
    });
    setVisible(prevState => !prevState);
  };

  return /*#__PURE__*/React.createElement(Input, _extends({}, rest, {
    ref: useMergeRefs([ref, inputRef]),
    type: visible ? 'text' : 'password',
    prefix: null,
    suffix: /*#__PURE__*/React.createElement(EyeButton, {
      visible: visible,
      onClick: handleVisibility
    })
  }));
});
Password.displayName = 'Password';
Password.defaultProps = {
  error: false,
  success: false,
  defaultVisible: false
};
process.env.NODE_ENV !== "production" ? Password.propTypes = {
  /**
   * Sets visible password as default
   */
  defaultVisible: PropTypes.bool,

  /**
   * Sets if input is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Sets if input is invalid
   */
  error: PropTypes.bool,

  /**
   * Sets if input is success
   */
  success: PropTypes.bool,

  /**
   * Sets the placeholder
   */
  placeholder: PropTypes.string,

  /**
   * Sets the value. Used for **Uncontrolled** component
   */
  defaultValue: PropTypes.any,

  /**
   * Sets input's value. Use it for controlled component or `defaultValue` for uncontrolled.
   */
  value: PropTypes.any,

  /**
   * Callback fired when the value is changed. `function(event: object) = {}`.
   * You can pull out the new value by accessing event.target.value (string).
   */
  onChange: PropTypes.func
} : void 0;
export default Password;